import { OrganizationInvitationDetailsState } from "@idw-types/state/organization-invitation-details-state";
import { getOrganizationInvitationDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getOrganizationInvitationDetailsDataState = createSelector(getOrganizationInvitationDetailsState, (state: OrganizationInvitationDetailsState) => {
    return {
        isLoadingAxnAdminUserInvitation: state.organizationInvitation.isLoading,
        axnAdminUserInvitation: state.organizationInvitation.organizationInvitation
    };
});